module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateSlotDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateSlotEditModal",
    attrs: {
      "id": "missionSlotTemplateSlotEditModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.slot.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionSlotTemplateSlotEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlotTemplateSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.title'),
      "state": _vm.missionSlotTemplateSlotEditTitleState,
      "feedback": _vm.missionSlotTemplateSlotEditTitleFeedback,
      "description": _vm.$t('mission.slot.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.title = $$v
      },
      expression: "missionSlotTemplateSlotEditData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.description),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.description = $$v
      },
      expression: "missionSlotTemplateSlotEditData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateSlotEditDifficultyOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.difficulty),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.difficulty = $$v
      },
      expression: "missionSlotTemplateSlotEditData.difficulty"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.reserve),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.reserve = $$v
      },
      expression: "missionSlotTemplateSlotEditData.reserve"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.blocked),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.blocked = $$v
      },
      expression: "missionSlotTemplateSlotEditData.blocked"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.detailedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionSlotTemplateSlotEditDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionSlotTemplateSlotEditDetailedDescriptionEditorOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.detailedDescription),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.detailedDescription = $$v
      },
      expression: "missionSlotTemplateSlotEditData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.moveAfter'),
      "state": "success",
      "description": _vm.$t('mission.slot.moveAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateSlotEditMoveAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditMoveAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditMoveAfter = $$v
      },
      expression: "missionSlotTemplateSlotEditMoveAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlotTemplateSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b8b46e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotEditModal.vue
// module id = 488
// module chunks = 0